<template>
  <div class="home">
    <!-- <el-affix> -->
      <el-row  type="flex" justify="center" style="background-color: #ffffff; opacity: 1.0; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);">
        <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12">
          <!-- <el-col :xs="16" :sm="12" :md="12" :lg="14" :xl="12">Haolin Lu</el-col>color
        <el-col :xs="4" :sm="6" :md="8" :lg="9" :xl="11"><a href="https://sheaton1.github.io/">Xiangtong Chu</a></el-col> -->
        <el-row justify="space-between">
          <el-col :span="10" style="padding-top: 10px; padding-bottom: 10px;">
            <t style="font-size:25px; word-wrap:break-word; word-break:break-all; color:#2c3e50 ; font-family:AliHeavy;" >Haolin Lu</t>
            <t style="font-size:20px; word-wrap:break-word; word-break:break-all; color: #2c3e50; font-family:SimHei; position: relative; bottom: 1.6px;" >  鲁昊霖</t>
          </el-col>
          <el-col :span="8.5" style="padding-top: 10px; padding-bottom: 10px;">
              <t style="font-size:25px; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color:#000 ; font-family:AliHeavy;" > </t>
              <a href="#id-publication"><t style="font-size:15x; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color: #2c3e50">Publications</t></a>
              <t style="font-size:25px; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color:#000 ; font-family:AliHeavy;" >&emsp;</t>
              <a href="#id-projects"><t style="font-size:15x; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color: #2c3e50">Projects</t></a>
              <t style="font-size:25px; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color:#000 ; font-family:AliHeavy;" >&emsp;</t>
              <a href="#id-games"><t style="font-size:15x; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color: #2c3e50">Games</t></a>
              <t style="font-size:25px; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color:#000 ; font-family:AliHeavy;" >&emsp;</t>
              <a href="#id-visualarts"><t style="font-size:15x; word-wrap:break-word; word-break:break-all; font-family:AliMedium; color: #2c3e50">Visual-Arts</t></a>
            </el-col>
        </el-row>
        </el-col>
      </el-row>
    <!-- </el-affix> -->
    <el-backtop :right="100" :bottom="70" />

    <!-- HEADER -->
    <el-row class="row" style="padding-top: 40px;padding-bottom: 5px;background:#ffffff" type="flex" justify="center" >
      <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12" style="background:#ffffff">
        <el-container>
          <el-row class="row-bg" justify="space-between" align="top">
            <el-col :xs="8" :sm="6" :md="6" :lg="6" :xl="5" style="padding-top: 20px">
              <el-image class="el-card" style="width: 100%; width: 100%;" src="https://SuikaSibyl.github.io/files/homepage/avater.webp" :fit="fit" />
            </el-col>
            <el-col :xs="24" :sm="24" :md="14" :lg="16" :xl="18">
              <p class="content-font" style="font-size: 100%;">
                Hi! I am a first-year PhD student at UC San Diego, advised by <a href="https://cseweb.ucsd.edu/~ravir/" target="_blank">Prof. Ravi Ramamoorthi</a>,
                and also work closely with <a href="https://cseweb.ucsd.edu/~tzli/" target="_blank">Prof. Tzu-Mao Li</a>. 
                Before that, I was a research intern @ <a href="https://www.mpi-inf.mpg.de/departments/computer-graphics" target="_blank">D4, Max Planck Institute for Informatics</a>,
                advised by <a href="https://sampling.mpi-inf.mpg.de/" target="_blank">Prof. Gurprit Singh</a>.
                I have also fortunately worked with <a href="https://dvicini.github.io/" target="_blank">Dr. Delio Vicini</a>,
                <a href="https://kuiwuchn.github.io/" target="_blank">Dr. Kui Wu</a>
                and <a href="https://cs.uwaterloo.ca/~thachisu/" target="_blank">Prof. Toshiya Hachisuka</a>.
              </p>
              <p class="content-font" style="font-size: 100%;">
                I received my master degree in Computer Science from UC San Diego, advised by Prof. <a href="https://cseweb.ucsd.edu/~tzli/" target="_blank">Tzu-Mao Li</a>.
                I received my bachelor's degree in Digital Media Technology from Zhejiang University, advised
                by Prof. <a href="http://www.cad.zju.edu.cn/home/rwang/" target="_blank">Rui Wang</a>. 
                During my undergraduate years, I worked at <a href="https://www.lightspeed-studios.com/" target="_blank">Tencent Lightspeed and Quantum Studios</a>, 
                <a href="https://www.raysengine.com/" target="_blank">RaysEngine</a>, <a href="https://www.neteasegames.com/" target="_blank">Netease
                Interactive Entertainment</a> as a <i>Technical Artist</i> or <i>Game Engine Programmer</i> intern.
              </p>
              <p class="content-font" style="font-size: 100%;">
                In addition to my academic interests, I enjoy creating various kinds of artwork, including painting, modeling, photography, video games, and rendering!
              </p>
              <el-button><a href="https://github.com/SuikaSibyl" target="_blank">
                    <span style="position: relative; top: 2.0px;">
                        <svg class="svg-inline--fa fa-github fa-w-16" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="github" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 496 512" data-fa-i2svg="" width="18px" height="18px"><path fill="currentColor" d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path></svg><!-- <i class="fab fa-github"></i> Font Awesome fontawesome.com -->
                    </span>
                    <t style="position: relative; bottom: 1.0px; font-size:15px;">&nbsp;Github</t></a>
                  </el-button>
                  <el-button><a href="mailto:hal128@ucsd.edu" target="_blank">
                    <span style="position: relative; top: 2.0px;">
                    <svg class="svg-inline--fa fa-envelope" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="envelope" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg="" width="18px" height="18px"><path fill="currentColor" d="M256 352c-16.53 0-33.06-5.422-47.16-16.41L0 173.2V400C0 426.5 21.49 448 48 448h416c26.51 0 48-21.49 48-48V173.2l-208.8 162.5C289.1 346.6 272.5 352 256 352zM16.29 145.3l212.2 165.1c16.19 12.6 38.87 12.6 55.06 0l212.2-165.1C505.1 137.3 512 125 512 112C512 85.49 490.5 64 464 64h-416C21.49 64 0 85.49 0 112C0 125 6.01 137.3 16.29 145.3z"></path></svg><!-- <i class="fas fa-envelope"></i> Font Awesome fontawesome.com -->
                    </span>
                    <t style="position: relative; bottom: 1.1px; font-size:15px;">&nbsp;hal128@ucsd.edu</t></a>
                  </el-button>
            </el-col>
          </el-row>
        </el-container>
        <br>
      </el-col>
    </el-row>
    <!-- Publications -->
    <el-row class="row" style="padding-top: 0px;padding-bottom: 10px;background:#ffffff" type="flex" justify="center" id="id-publication">
      <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12">
        <el-divider></el-divider>
        <h2 style="font-size:30px;  word-wrap:break-word; word-break:break-all; font-family:AliBold;" >Publications</h2>
        <el-row class="row-bg" justify="space-between" align="top">
          <el-card shadow="never" key = "Real-Time Path Guiding Using Bounding Voxel Sampling" style="background-color: rgba(240, 247, 255, 1); border-color:rgba(205, 230, 255, 1)">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="2">
                    <el-image style="width=100%; margin-bottom: 0.5em;" src="https://SuikaSibyl.github.io/files/homepage/artworks/gilo-cover.webp" :fit="fill" />
                  </el-col>
              <el-col :xs="17" :sm="17" :md="17" :lg="19" :xl="21" style="position: relative;">
                    <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">Gaussian Integral Linear Operators for Precomputed Graphics</h2>
                    <p style="font-size:0.9em; margin-top: 0.2em; margin-bottom: 0px;">
                      <b>Haolin Lu</b>,
                      <a href="https://yashbelhe.github.io/" target="_blank">Yash Belhe</a>, 
                      <a href="https://sampling.mpi-inf.mpg.de/" target="_blank">Gurprit Singh</a>, 
                      <a href="https://cseweb.ucsd.edu/~tzli/" target="_blank">Tzu-Mao Li</a>, 
                      <a href="https://cs.uwaterloo.ca/~thachisu/" target="_blank">Toshiya Hachisuka</a></p>
                      <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 0.5em;"><i><b>🏆<font color="#ffb02e"> Best Paper Honorable Mention!</font></b></i></p>
                      <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 1em;"><i>ACM Transactions on Graphics (Proceedings of SIGGRAPH Asia 2025)</i></p>
                    <el-button size="small"><a href="https://suikasibyl.github.io/gilo/" target="_blank">Project Page</a></el-button>
                    <el-button size="small"><a href="https://suikasibyl.github.io/files/gilo/paper.pdf" target="_blank" style="text-decoration: none;">Paper</a></el-button>
                    <el-button size="small"><a href="https://suikasibyl.github.io/files/gilo/supplementary.pdf" target="_blank" style="text-decoration: none;">Supplementary</a></el-button>
                  </el-col>
            </el-row>
          </el-card>
          <el-card shadow="never" key = "Real-Time Path Guiding Using Bounding Voxel Sampling" style="background-color: rgba(240, 247, 255, 1); border-color:rgba(205, 230, 255, 1)">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="2">
                    <el-image style="width=100%; margin-bottom: 0.5em;" src="https://SuikaSibyl.github.io/files/homepage/artworks/vvmc-cover.webp" :fit="fill" />
                  </el-col>
              <el-col :xs="17" :sm="17" :md="17" :lg="19" :xl="21" style="position: relative;">
                    <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">Vector-Valued Monte Carlo Integration Using Ratio Control Variates</h2>
                    <p style="font-size:0.9em; margin-top: 0.2em; margin-bottom: 0px;">
                      <b>Haolin Lu</b>,
                      <a href="https://dvicini.github.io/" target="_blank">Delio Vicini</a>, 
                      <a href="https://weschang.com/" target="_blank">Wesley Chang</a>, 
                      <a href="https://cseweb.ucsd.edu/~tzli/" target="_blank">Tzu-Mao Li</a></p>
                      <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 0.5em;"><i><b>🏆<font color="#ffb02e"> Best Paper Award!</font></b></i></p>
                      <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 1em;"><i>ACM Transactions on Graphics (Proceedings of SIGGRAPH 2025)</i></p>
                    <el-button size="small"><a href="https://suikasibyl.github.io/vvmc/" target="_blank">Project Page</a></el-button>
                    <el-button size="small"><a href="https://suikasibyl.github.io/files/vvmc/paper.pdf" target="_blank" style="text-decoration: none;">Paper</a></el-button>
                    <el-button size="small"><a href="https://suikasibyl.github.io/files/vvmc/supplementary.pdf" target="_blank" style="text-decoration: none;">Supplementary</a></el-button>
                  </el-col>
            </el-row>
          </el-card>
          <el-card shadow="never" key = "BSDF Importance Sampling using a Diffusion Model">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="2">
                    <el-image style="width=100%; margin-bottom: 0.5em;" src="https://lwwu2.github.io/images/25reparam.png" :fit="fill" />
                  </el-col>
              <el-col :xs="17" :sm="17" :md="17" :lg="19" :xl="21" style="position: relative;">
                    <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">Neural BRDF Importance Sampling by Reparameterization</h2>
                    <p style="font-size:0.9em; margin-top: 0.2em; margin-bottom: 0px;">
                      <a href="https://lwwu2.github.io/" target="_blank">Liwen Wu</a>, 
                      <a href="https://sai-bi.github.io/" target="_blank">Sai Bi</a>, 
                      <a href="https://zexiangxu.github.io/" target="_blank">Zexiang Xu</a>, 
                      <a href="https://www.cs.unc.edu/~airsplay/" target="_blank">Hao Tan</a>, 
                      <a href="https://kai-46.github.io/website/" target="_blank">Kai Zhang</a>, 
                      <a href="https://scholar.google.com/citations?user=NLxrmYQAAAAJ&hl=en" target="_blank">Fujun Luan</a>, 
                      <b>Haolin Lu</b>,
                      <a href="https://cseweb.ucsd.edu/~ravir/" target="_blank">Ravi Ramamoorthi</a>, 
                    </p>
                    <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 1em;"><i>SIGGRAPH 2025 (conference track)</i></p>
                    <el-button size="small"><a href="https://lwwu2.github.io/" target="_blank">Project Page</a></el-button>
                  </el-col>
            </el-row>
          </el-card>
          <el-card shadow="never" key = "BSDF Importance Sampling using a Diffusion Model">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="2">
                    <el-image style="width=100%; margin-bottom: 0.5em;" src="https://SuikaSibyl.github.io/files/homepage/artworks/brdfdiffusion.webp" :fit="fill" />
                  </el-col>
              <el-col :xs="17" :sm="17" :md="17" :lg="19" :xl="21" style="position: relative;">
                    <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">BSDF Importance Sampling using a Diffusion Model</h2>
                    <p style="font-size:0.9em; margin-top: 0.2em; margin-bottom: 0px;">
                      <a href="https://fzy28.github.io/" target="_blank">Ziyang Fu</a>, 
                      <a href="https://yashbelhe.github.io/" target="_blank">Yash Belhe</a>, 
                      <b>Haolin Lu</b>,
                      <a href="https://scholar.google.com/citations?user=_7OXdUcAAAAJ&hl=en/" target="_blank">Liwen Wu</a>, 
                      <a href="https://bingxu.tech/" target="_blank">Bing Xu</a>, 
                      <a href="https://cseweb.ucsd.edu/~tzli/" target="_blank">Tzu-Mao Li</a></p>
                    <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 1em;"><i>SIGGRAPH Asia 2024 (conference track)</i></p>
                    <el-button size="small"><a href="https://fzy28.github.io/BSDF_diffusion_sampling_web" target="_blank">Project Page</a></el-button>
                    <el-button size="small"><a href="https://fzy28.github.io/BSDF_diffusion_sampling_web/main.pdf" target="_blank" style="text-decoration: none;">Paper</a></el-button>
                    <el-button size="small"><a href="https://fzy28.github.io/BSDF_diffusion_sampling_web/sup.pdf" target="_blank" style="text-decoration: none;">Supplementary</a></el-button>
                  </el-col>
            </el-row>
          </el-card>
          <el-card shadow="never" key = "Real-Time Path Guiding Using Bounding Voxel Sampling" style="background-color: rgba(240, 247, 255, 1); border-color:rgba(205, 230, 255, 1)">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="2">
                    <el-image style="width=100%; margin-bottom: 0.5em;" src="https://SuikaSibyl.github.io/files/homepage/artworks/vxpg-cover.webp" :fit="fill" />
                  </el-col>
              <el-col :xs="17" :sm="17" :md="17" :lg="19" :xl="21" style="position: relative;">
                    <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">Real-Time Path Guiding Using Bounding Voxel Sampling</h2>
                    <p style="font-size:0.9em; margin-top: 0.2em; margin-bottom: 0px;">
                      <b>Haolin Lu</b>,
                      <a href="https://weschang.com/" target="_blank">Wesley Chang</a>, 
                      <a href="https://www.linkedin.com/in/trevor-hedstrom-9abb6362/" target="_blank">Trevor Hedstrom</a>, 
                      <a href="https://cseweb.ucsd.edu/~tzli/" target="_blank">Tzu-Mao Li</a></p>
                    <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 1em;"><i>ACM Transactions on Graphics (Proceedings of SIGGRAPH 2024)</i></p>
                    <el-button size="small"><a href="https://suikasibyl.github.io/vxpg" target="_blank">Project Page</a></el-button>
                    <el-button size="small"><a href="https://SuikaSibyl.github.io/files/vxpg/paper.pdf" target="_blank" style="text-decoration: none;">Paper</a></el-button>
                    <el-button size="small"><a href="https://SuikaSibyl.github.io/files/vxpg/supplementary.pdf" target="_blank" style="text-decoration: none;">Supplementary</a></el-button>
                  </el-col>
            </el-row>
          </el-card>
        </el-row>
        <el-row class="row-bg" justify="space-between" align="top">
          <el-card shadow="never" key = "TIVEE: Visual Exploration and Explanation of Badminton Tactics in Immersive Visualizations">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-col :xs="6" :sm="6" :md="6" :lg="4" :xl="2">
                <el-image style="margin-bottom: 0.5em;" src="https://SuikaSibyl.github.io/files/homepage/artworks/cover-badminton.webp" fit="fill" />
              </el-col>
              <el-col :xs="17" :sm="17" :md="17" :lg="19" :xl="21" style="position: relative;">
                <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">TIVEE: Visual Exploration and Explanation of Badminton Tactics in Immersive Visualizations</h2>
                <p style="font-size:0.9em; margin-top: 0.2em; margin-bottom: 0px;">
                  <a href="https://sheaton1.github.io/">Xiangtong Chu</a>,
                  <a href="https://ssxiexiao.github.io/">Xiao Xie</a>, Shuainan Ye, <b>Haolin Lu</b>, Hongguang Xiao, Zeqing Yuan, Zhutian Chen, Hui Zhang, <a href="https://ssxiexiao.github.io/">Yingcai Wu</a></p>
                <p style="font-size:0.9em; margin-top: 0.4em; margin-bottom: 1em;"><i>TVCG (IEEE Transactions on Visualization and Computer Graphics), January 2022</i></p>
                <el-button size="small"><a href="https://ieeexplore.ieee.org/document/9557225" target="_blank" style="text-decoration: none;">Paper</a></el-button>
                <el-button size="small"><a href="https://virtual.ieeevis.org/year/2021/paper_v-full-1038.html" target="_blank" style="text-decoration: none;">Video</a></el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-row>
      </el-col>
    </el-row>
    <!-- Projects -->
    <el-row class="row" style="padding-top: 0px;padding-bottom: 10px;background:#ffffff" type="flex" justify="center" id="id-projects">
      <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12">
        <el-divider></el-divider>
        <h2 style="font-size:30px;  word-wrap:break-word; word-break:break-all; font-family:AliBold;" >Selected Projects</h2>
        <el-row class="row-bg" justify="space-between" align="top">
          <el-col v-for="(project, i) in project_list" :key=i :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-card shadow="never" key = "TIVEE: Visual Exploration and Explanation of Badminton Tactics in Immersive Visualizations">
                <el-row class="row-bg" justify="space-between" align="top">
                  <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="2">
                    <el-image style="width:100%; margin-bottom: 0.5em;" :src=project.cover_url :fit="fill" />
                  </el-col>
                  <el-col :xs="19" :sm="19" :md="19" :lg="20" :xl="21">
                    <h2 style="font-size:1em; margin-top: 0px; margin-bottom: 0px;">{{project.name}}</h2>
                    <p style="font-size:0.9em; margin-top: 0.5em; margin-bottom: 1em;">{{project.description}}</p>
                    <el-button size="small" v-if="project.proj_page"><a :href=project.proj_page target="_blank" style="text-decoration: none;">Project Page</a></el-button>
                    <el-button size="small" v-if="project.video"><a :href=project.video target="_blank" style="text-decoration: none;">Video</a></el-button>
                    <el-button size="small" v-if="project.paper_chinese"><a :href=project.paper_chinese target="_blank" style="text-decoration: none;">Paper (Chinese)</a></el-button>
                    <el-button size="small" v-if="project.code"><a :href=project.code target="_blank" style="text-decoration: none;">Code</a></el-button>
                    <el-button size="small" v-if="project.patent"><a :href=project.patent target="_blank" style="text-decoration: none;">Patent</a></el-button>
                  </el-col>
                </el-row>
              </el-card>
            </el-row>

              <!-- <el-card shadow="never">
                <h2>{{project.name}}{{project.id}}</h2>
                <p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh.</p>
                <el-button size="small">View details >></el-button>
              </el-card> -->
            </el-col>
        </el-row>
      </el-col>
    </el-row>
     <!-- Artworks -->
     <el-row class="row" style="padding-top: 0px;padding-bottom: 10px;background:#ffffff" type="flex" justify="center" id="id-games">
      <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12">
        <el-divider></el-divider>
        <h2 style="font-size:30px;  word-wrap:break-word; word-break:break-all; font-family:AliBold;">Video Games</h2>
        <!-- <a name="portfolio"></a> -->
        <!-- Video Game -->
          <el-row class="row-bg" justify="space-between" align="top">
          <el-col v-for="(game, i) in game_list" :key=i :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-row class="row-bg" justify="space-between" align="top">
              <el-card shadow="never" key = "TIVEE: Visual Exploration and Explanation of Badminton Tactics in Immersive Visualizations">
                <el-row class="row-bg" justify="space-between" align="top">
                  <el-col :xs="24" :sm="24" :md="8" :lg="4" :xl="2">
                    <el-image style="width=100%; margin-bottom: 0.5em;" :src=game.cover :fit="fill" />
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="14" :lg="19" :xl="21">
                    <h2 style="font-size:1.05em; margin-top: 0px; margin-bottom: 0px;">{{game.name}}</h2>
                    <p style="font-size:0.9em; margin-top: 0.5em; margin-bottom: 1em;">{{game.description}}</p>
                    <el-button size="small" v-if="game.video"><a :href=game.video target="_blank" style="text-decoration: none;">Video</a></el-button>
                    <el-button size="small" v-if="game.download_link"><a :href=game.download_link target="_blank" style="text-decoration: none;">Download</a></el-button>
                  </el-col>
                </el-row>
              </el-card>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
     <el-row class="row" style="padding-top: 0px;padding-bottom: 10px;background:#ffffff" type="flex" justify="center" id="id-visualarts">
      <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12">
        <el-divider></el-divider>
        <!-- <a name="portfolio"></a> -->
        <!-- Video Game -->
        <h2 style="font-size:30px;  word-wrap:break-word; word-break:break-all; font-family:AliBold;">Visual Arts</h2>
          <el-col xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <water-fall class="container" :data=artworks :key='waterfall_id' :delay="true">
              <template #default="item">
                <div class="aw-container">
                  <img :src="item.src" class="aw-image">
                  <!-- <el-image style="margin: 0.em;" :src="item.src" fit="scale-down"/> -->
                  <div class="aw-overlay-1"></div>
                  <div class="aw-overlay" @click="preview(item.src, $event)">
                    <div class="aw-text"><t style="font-family:AliBold;">{{item.text}}</t><br/><t style="font-size: 14px;">{{item.type}}</t><br/>
                      <t style="font-size: 14px;">{{item.place}}</t></div>
                  </div>
                  <!-- <div class="aw-overlay" @click="preview(item.src, $event)" @load="onImgLoad($event)">
                    <div class="aw-text">Hello World</div>
                  </div> -->
                </div>
              </template>
            </water-fall>
          </el-col>

      </el-col>
    </el-row>
  </div>
  <el-row style="background:#ffffff" type="flex" justify="center" >
    <el-col :xs="21" :sm="21" :md="18" :lg="14" :xl="12">
      <el-divider></el-divider>
      <p style="text-align:center">Copyright © Haolin Lu. 2025</p>
    </el-col>
  </el-row>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import WaterFall from 'kuan-vue-waterfall';
import photoSwipe from 'kuan-vue-photoswipe';

export default {
  name: 'HomeView',
  components: {
    WaterFall,
  },
  data () {
    return {
      waterfall_id: 1,
      payload: {
        page: 1,
        size: 18,
      },
      total: 0,
        headings:['1Heading','2Heading','3Heading', '4Heading','5Heading','6Heading'],
        welcome: 'Haolin Lu │ 鲁昊霖',
        title_name: 'Project Name',
        hdgd: '270px',
        project_list: [
            { 
              id: 14, 
              name: 'SIByL Engine',
              cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/2023cover.webp',
              proj_page: 'https://github.com/SuikaSibyl/sibylengine/',
              description: 'My personal toy engine! It is a Vulkan based real-time rasterizer + ray tracing engine. Support python API with nanobind binding,\
              providng interoperation between Vulkan buffer and PyTorch tensor.\
              Including many engine facilities, e.g. RHI, scene graph, resource management, RDG. Here are many offline, real-time and inverse CG algorithms implemented!'
            },
            { 
              id: 13, 
              name: 'BDPT and MMLT on GPU with Simple Primal Sample Space Latent Nueral Mutation',
              cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/mltcover.webp',
              proj_page: 'https://suikasibyl.github.io/CSE272-Report-WebPage/',
              code: 'https://github.com/SuikaSibyl/SIByLEngine2023',
              description: 'Implement BDPT and MMT based on Vulkan ray tracing extension. Implemented neural important sampling\
              based on RealNVP to help with primal sample space mutation instead of importance sampling bounce direction. Ray tracing\
              part is implemented in SIByL 2023, and the neural netwrok is implemented in PyTorch, and these two parts are\
              communicated by local TCP socket in real-time.'
            },
            { 
              id: 12, 
              name: 'A Priori Frequency Analysis Based Real-Time Denoiser',
              cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_aaf.webp',
              proj_page: 'https://suikasibyl.github.io/CSE274-RealtimeDenoiser-WebPage',
              code: 'https://github.com/SuikaSibyl/SIByLEngine2022/commit/5e22fb2d1d25090dfa3c49761c78e0dc9522d4fb',
              description: 'Re-implemented some papers of Axis-Aligned Filter and Multiple Axis-Aligned filter. Construct\
              a real-time ray tracing application with real-time denoiser. Implemented in Vulkan with the ray tracing extension.'
            },
            // { 
            //   id: 11, 
            //   name: 'Misc Physics Simulation Implementation',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/appartcover.webp',
            //   proj_page: 'https://suikasibyl.github.io/MiscSimulation23/',
            //   description: 'Notes and results of some physics simulation demos implemented in around 2023.\
            //   Including PBD rigid body by shape matching, double pendulum, softbody tetrahedral and 2D FLIP fluid.'
            // },
            // { 
            //   id: 10, 
            //   name: 'Misc Path Tracing Implementation',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/hetvol_colored_sqw.webp',
            //   proj_page: ' https://suikasibyl.github.io/MiscPT23/',
            //   description: 'Results of some path tracing assignments in UCSD CSE 272: Advanced Image Synthesis.\
            //   Including some results of disney principled BSDF and volumetric path tracing.'
            // },
            // {
            //   id: 9,
            //   name: 'SIByL Engine 2021',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_hair.webp',
            //   code: 'https://github.com/SuikaSibyl/SIByLEngine2022',
            //   description: 'A personal toy engine, supporting many of my projects. Including various rasterizer pipeline\
            //   implementation with double backend (OpenGL + DirectX12).\
            //   In the hair demo, implemented many features like TAA and dithered soft edges, anisotropic materials, etc.'
            // },
            {
              id: 8,
              name: 'PBD Based Real-Time Rope System',
              cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover-rope.webp',
              video: 'https://youtu.be/mlxybQqx7JI',
              description: 'A real-time interactive rope simulation system in Unreal Engine 4 using C++.\
              Self-contained and engine-independent system from collision detection, acceleration structure to rope system,\
              which uses a hybrid approach with two simulation subsystems: PBD based dynamic rope & geometry based taut rope).'
            },
            { 
              id: 7,
              name: 'GPU-Driven Real-time Particle System Culling Rendering Pipeline',
              cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_particlesystem.webp',
              video: 'https://youtu.be/5IFsyKgNGTc',
              patent: 'http://epub.cnipa.gov.cn/patent/CN115830201A?8kt2YOWWXQBD=1687572070011',
              description: '(Undergraduate Thesis) Selected as outstanding undergraduate thesis. Proposed a new method for real-time particle system rendering.\
              The algorithm taking advantages of the Mesh shader feature in Nvidia GPU. It first fast clusters all the dynamic particles\
              and then do heuristic cluster-wise culling &automatic LoD switching. Implemented the algorithm in Vulkan from scratch.\
              Showing a significant improvement of performance adopting the method.',
              // paper_chinese: 'https://imagehost-suikasibyl-us.oss-us-west-1.aliyuncs.com/3180101046-%E9%B2%81%E6%98%8A%E9%9C%96-GPU%E9%A9%B1%E5%8A%A8%E7%9A%84%E5%AE%9E%E6%97%B6%E7%B2%92%E5%AD%90%E7%B3%BB%E7%BB%9F%E5%89%94%E9%99%A4%E7%BB%98%E5%88%B6%E7%AE%A1%E7%BA%BF%E7%A0%94%E7%A9%B6%E4%B8%8E%E5%AE%9E%E7%8E%B0%20%282%29.pdf',
            },
            // {
            //   id: 6,
            //   name: 'Implementation of Real-Time Rendering with Many Polygonal Area Lights',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_manylight.webp',
            //   code: 'https://github.com/SuikaSibyl/XiguaGraphic',
            //   video: 'https://youtu.be/huB4weoudY4',
            //   description: 'Re-implemented the SIGGRAPH paper Analytic Spherical Harmonic Gradients for Real-Time Rendering with Many Polygonal Area Lights.\
            //   Use SSDO to add GI. Support traslucent material under multi polygon lights, which is not mentioned in the paper.'
            // },
            // {
            //   id: 5,
            //   name: 'Implementation of Real-time Neural Super-Resolution',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_nssr.webp',
            //   code: 'https://github.com/SuikaSibyl/ReproduceNSRR',
            //   video: 'https://www.bilibili.com/video/BV14f4y1g7xD/?share_source=copy_web&vd_source=dd17b32e7f12a9a9090ecba3ea7c6c5c',
            //   description: 'Re-implement the paper Neural Supersampling for Real-time Rendering (SIGGRAPH 2020) by Pytorch.\
            //   The paper proposed a neural network using Temporal methods (which is also used by DLSS2.0) and realized real-time supersampling.\
            //   The author did not open source the code and database, so I implemented from scratch and created my own dataset using Unity.'
            // },
            // {
            //   id: 4,
            //   name: 'CUDA Path Tracer',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_raytracer.webp',
            //   code: 'https://github.com/SuikaSibyl/XiguaGraphic',
            //   video: 'https://www.bilibili.com/video/BV1pF411e7Na',
            //   description: ' A CUDA based Path Tracer with BVH accleration. Embedded in the real-time renderer with progressive Monte-Carlo convergence.\
            //   The real-time rasterizer part includes PCF Soft Shadow, the Split Sum Approximation IBL, and Post processing effects like SSAO & SSDO. '
            // },
            // {
            //   id: 3,
            //   name: 'Pontoon Bride Simulation in Virtual Reality',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_vrbridge.webp',
            //   video: 'https://www.bilibili.com/video/BV1K44y147B5',
            //   description: 'A pontoon bridge simulation system on Unity + HTC Vive. Designed three levels\
            //   of bounyancy computation and an algorithm to enhance the sense of floating via camera pose manipulation.'
            // },
            // {
            //   id: 2,
            //   name: 'Implicit Function Ray Marcher & Morphing',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_implicit.webp',
            //   code: 'https://github.com/SuikaSibyl/ImplicitFunctionRayMarcher',
            //   video: 'https://www.bilibili.com/video/BV1MT4y1Z7UR',
            //   description: 'Re-implement the paper Real-Time Ray Tracing of Implicit Surfaces on the GPU to do implicit function ray marching.\
            //     Implemented in OpenGL fragment shader, with simple lighting & shadowing and 60+ fps on RTX 2070s.\
            //     Approximate meshes with metaballs and perform 3D morphing by interpolation between two implicit functions.'
            // },
            // {
            //   id: 1,
            //   name: 'Free Form Deformation Editor',
            //   cover_url: 'https://SuikaSibyl.github.io/files/homepage/artworks/cover_freeformdeformation.webp',
            //   code: 'https://github.com/SuikaSibyl/FreeFormDeformation',
            //   description: 'Iteractive Free Form Deformation Edtor implemented with OpenGL & Qt.'
            // },
            // {
            //   id: 0,
            //   name: 'OpenGL FPS Demo',
            //   cover_url: 'https://imagehost-suikasibyl-us.oss-us-west-1.aliyuncs.com/cover_fps.png',
            //   code: 'https://github.com/SuikaSibyl/SimpleFps',
            //   video: 'https://www.bilibili.com/video/BV1RT4y1R7dT',
            //   description: 'A simple FPS game based on OpenGL from scratch. Implement shadow mapping,\
            //   normal mapping, ui, sound effects, collision physics, and simple animation.',
            // },
        ],
        game_list: [
            {
              id: 2,
              name: "Sisphury's Illusion | Triangle",
              description: 'What happens when visual illusion becomes reality? Sisphury\'s illusion is a visual illusion \
              puzzle game in which players can fully control the perspective. All visual dislocations in the game will \
              become physical reality. You need to find the right angle of view in the game, so that some isolated objects can \
              connect and influence each other.',
              cover: "https://i.loli.net/2021/10/25/ofG4Nv23RQEKjUu.png",
              video: "https://www.bilibili.com/video/BV1uM4y1N75u",
              download_link: 'https://drive.google.com/file/d/11l420ZTeBqP5pFXheBix4msmpqa8ogsP/view?usp=sharing',
            }, 
            {
              id: 1,
              name: "Fimaker | Light Studio",
              description: 'Have you ever thought about what will happen when the films are stacked and projected?\
              FILMAKER is a platform puzzle game. You can record your operation in advance,\
              superimpose and project the recorded film on the screen, and then, with the help of the shadow,\
              operate the noumenon villain to go through the barriers. You need to adjust the recorded film and use some characteristics of the film\
              to reach the end.',
              cover: "https://i.loli.net/2021/10/24/YpIk7AEcymHGeuZ.png",
              video: "https://www.bilibili.com/video/BV1Qg411M77x",
              download_link: 'https://drive.google.com/file/d/1vXmFbzuTg6zVeHxZ5Y88oAwplTRhsBzi/view?usp=sharing',
            }, 
            {
              id: 0,
              name: "For Hue | Light Studio",
              description: 'For Hue is a journey full of sense of achievement! Collect the lost color crystals,\
              change the color of yourself and the objects around you, light up the color tree lights on the journey,\
              and save the world where the color has disappeared! Use color to go through dangerous environments and complex mechanisms!',
              cover: "https://i.loli.net/2021/10/24/eQD9MGUJvA2B8LO.jpg",
              video: "https://www.bilibili.com/video/BV1xf4y1t75c"
            }
        ],
        artworks: [
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/waiting.webp', text: 'WAITING', type: 'photography', place: 'La Jolla'},
          { src: 'https://i.loli.net/2021/10/23/VpkBD5NWS1UwEAz.jpg', labels: ["Photo"], text: 'TREE', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/wbn369uU2DGxHje.png', labels: ["Modeling"], text: 'ロベルタ', type: '3d-model'},
          { src: 'https://i.loli.net/2021/10/24/YpIk7AEcymHGeuZ.png', text: 'FILMAKER', type: 'poster'},
          { src: 'https://i.loli.net/2021/10/23/7O9JG3LTdzfwuin.png', labels: ["Modeling"], text: 'ロベルタ', type: '3d-model'},
          { src: 'https://i.loli.net/2021/10/23/1GkmDKPVbgoascB.jpg', labels: ["Photo"], text: 'EAVES-1', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/cTYf7JM3LOVUSyN.jpg', labels: ["Photo"], text: 'EAVES-0', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/DfMRiIVBO23Nbnz.png', text: 'OPERA', type: 'drawing'},
          { src: 'https://i.loli.net/2021/10/23/oZfdNiRuTJqlOBs.jpg', labels: ["Photo"], text: 'LEAVES', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/nARaJzQ3H4gGp6b.jpg', labels: ["Photo"], text: 'INTIME', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/Lcd1EfhyXlx5zOH.jpg', labels: ["Photo"], text: 'LADY', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/FjWvlpqgbncDo8i.jpg', labels: ["Photo"], text: 'GOOSE', type: 'photography', place: 'Hangzhou'},
          { src: 'https://i.loli.net/2021/10/23/mUYPrNWqX5nQ1Tu.png', labels: ["Modeling"], text: 'ロベルタ', type: '3d-model'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/arithmetic.webp', text: 'ARITHMETIC', type: 'photography', place: 'La Jolla'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/ramp.webp', text: 'RAMP', type: 'photography', place: 'La Jolla'},
          { src: 'https://i.loli.net/2021/10/23/MUwqdLYJORotBfZ.png', text: 'GOLDFISH', type: 'drawing'},
          { src: 'https://i.loli.net/2021/10/23/LMF4N6ZvlkHrjy2.jpg', text: 'WORLD', type: 'drawing'},
          { src: 'https://i.loli.net/2021/10/24/FWNcn6xv4Pser9R.png', text: 'BATTLE', type: 'digital painting'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/staircase.webp', text: 'STAIRCASE', type: 'oil painting'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/trashcan.webp', text: 'TRASHCAN', type: 'oil painting'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/mr-pig.webp', text: 'MR.PIG', type: 'digital painting'},
          { src: 'https://i.loli.net/2021/10/24/eQD9MGUJvA2B8LO.jpg', text: 'FORHUE', type: 'poster'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/mrs-sisphury.webp', text: 'MRS.SISPHURY', type: 'digital painting'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/pingpong.webp', text: 'PING-PONG!', type: 'digital painting'},
          { src: 'https://i.loli.net/2021/10/24/13W5qvXSfOThk2V.png', text: 'DUST', type: '3d-model'},
          { src: 'https://i.loli.net/2021/10/23/nYljhQCg1rDMKAN.jpg', text: 'LOTUS', type: 'watercolor'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/mouse.webp', text: 'MOUSE', type: 'digital painting'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/double.webp', text: 'DOUBLE', type: 'digital painting'},
          { src: 'https://i.loli.net/2021/10/24/xrVLzXESaAPGcFs.png', text: 'DUST', type: '3d-model'},
          { src: 'https://i.loli.net/2021/10/23/vsXxmVglMoAdYn2.png', text: 'CLOVER', type: 'drawing'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/deepblue.webp', text: 'DEEP BLUE', type: 'digital painting'},
          { src: 'https://i.loli.net/2021/10/25/ofG4Nv23RQEKjUu.png', text: 'SISPHURY', type: 'poster'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/player.webp', text: 'PLAYER', type: 'digital painting'},
          { src: 'https://SuikaSibyl.github.io/files/homepage/artworks/embryo.webp', text: 'EMBRYO', type: 'oil painting'},
          { src: 'https://i.loli.net/2021/10/23/HbYW3q46um8ZK5g.jpg', text: 'BOULEVARD', type: 'watercolor'},
          { src: 'https://i.loli.net/2021/10/24/ALRbBroslZShG8p.png', text: 'WOLVERINE', type: 'digital painting'},
          { src: 'https://i.loli.net/2021/10/23/jn74uLzUdWkaV9X.png', text: 'FLOWER', type: 'drawing'},
          { src: 'https://i.loli.net/2021/10/24/5Kpiu1Lh8XvCway.png', text: 'DUST', type: '3d-model'},
          { src: 'https://i.loli.net/2021/10/23/lmP1boXuaTSk6Dj.jpg', text: 'PAVILION', type: 'watercolor'},
          
        ],
        loaded_works: 0,
    };
  },
  methods: {
    refresh(){
			this.waterfall_id++;
		},
    preview(url) {
      photoSwipe.preview(url);
    },
    onImgLoad() {
      console.log("Hello");
      this.loaded_works++;
      if(this.loaded_works==28)
        this.refresh();
      let that = this;
      that.waterfall_id = that.waterfall_id + 1;
    }
  },
  mounted() {
    let that = this;
    window.onresize = function windowResize() {
      var w = window.innerWidth
      var h = 270
      if (w > 1180) {
        h = 270
      } else {
        h = 0.22 * w
      }
      that.hdgd = h + 'px'
      console.log(that.hdgd)
    }
  }
}
</script>

<style>
  a{
    text-decoration: none;
    color: #007bff;
  }
  a:hover{
    text-decoration: underline;
    color: #0056b3;
  }

  .el-card{
    background:#fdfdfd;
    display: inline-block;
    margin: 0.3em;
    border-radius:20px;
    width: 100%;
  }
  .grid-content {
    /* background: rgb(14, 214, 131); */
    border-radius: 4px;
    min-height: 80px;
  }
  .text {
    font-size: 14px;
  }
  .item {
    padding: 18px 0;
  }
  .header-h2{
    color:#fff ;
    font-family:AliHeavy;
  }
.row-header{
  background:#409eff;
}
  .content-font{
    font-family:AliRegular;
  }
  .container {
  min-height: 90vh;
}
.card {
  padding: 10px;
  background-color: white;
  border-radius: 3px;
  color: #666;
  line-height: 1.5;
  word-break: break-all;
  .img {
    width: 100%;
    margin-bottom: 5px;
    cursor: pointer;
  }
}
.halo-btn {
  margin: 100px auto;
  display: block;
}
.aw-container {
  padding: 5px;
  background-color: white;
  border-radius: 3px;
  color: #666;
  line-height: 1.5;
  word-break: break-all;
}

.aw-image {
  display: block;
  width: 100%;
  height: auto;
}

.aw-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  /* transition: .5s ease; */
  /* background-color: #008CBA; */
}

.aw-overlay-1 {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
  /* transition: .5s ease; */
  /* background-color: #008CBA; */
}

.aw-container:hover .aw-overlay {
  opacity: 1.0;
  backdrop-filter: blur(5px);
  /* transition: .5s ease; */
}

.aw-container:hover .aw-overlay-1 {
  opacity: 0.6;
  background-color: #008CBA;
  transition: .3s ease;
}

.aw-text {
  color: white;
  font-size: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
}

</style>